import { MeasuredStyles } from '@/features/ui/inputs/components/ValidationStatusMessage/types'
import { RefObject, useCallback, useState } from 'react'
import { View } from 'react-native'

const gapBetweenAnchorAndMessage = 4

export const useMeasuredStyles = (
    ref: RefObject<View | null>
): [MeasuredStyles | undefined, () => Promise<void>] => {
    const [styles, setStyles] = useState<MeasuredStyles>()

    const measure = useCallback(async () => {
        ref.current?.measure((_, _1, _2, height) => {
            setStyles({ top: height + gapBetweenAnchorAndMessage })
        })
    }, [ref])

    return [styles, measure]
}
